import { render, staticRenderFns } from "./history-meal.vue?vue&type=template&id=085bab0f&scoped=true"
import script from "./history-meal.vue?vue&type=script&lang=ts"
export * from "./history-meal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085bab0f",
  null
  
)

export default component.exports